module.exports = __webpack_public_path__ + "img/ios.6d183272.png";